<template lang="pug">
	section.toc-container
		div.toc-row(v-if="title" :class="{sticky: sticky}")
			h3
				span.row-image(:style="`background: url('https://web-resources.savingforcollege.com/images/table-of-contents-icon.png') no-repeat;background-size: contain;`")
				span.text
					| {{title}}
		div.table-of-contents
			ul
				li(v-for="content of toc" :class="{ active: trimmedUrl(content.url) == currentUrl}")
					a(:href="content.url")
						| {{content.title}}
					ul(v-if="content.toc")
						li(v-for="content of toc" :class="{ active: trimmedUrl(content.url) == currentUrl}")
							a(:href="content.url")
								| {{content.title}}
</template>

<style lang="stylus" scoped>
@import '~assets/css/variables.styl'

.sticky
	position sticky
	top 60px

.toc-container
	padding: 0
	@media (max-width: 768px)
		padding: 0 15px
	.toc-row
		h3
			font-size: body-font-size-lg

			.row-image
				height: 30px
				width: 30px
				display: inline-block
				margin-right: 15px
				position: relative
				top: 7px
	.table-of-contents
		ul
			list-style: none
			padding: 15px 0
			li
				border-bottom: 1px sfc-pale-gray solid
				font-size: body-font-size-md
				width: 100%
				color: body-font-color
				transition-all()
				&.active
					border-bottom: 1px solid sfc-blue
					a
						border-bottom: 1px solid sfc-blue
				a
					color: body-font-color
					border-bottom: 1px solid #fff
					transition-all()
					padding: 7.5px 0
					display: block
				&:hover
					border-bottom: 1px solid sfc-blue
					a
						border-bottom: 1px solid sfc-blue
						&:hover
							text-decoration: none



</style>


<script>
	import SfcTrackingService from "@/lib/sfc-tracking-service.js"
	export default {

		props: ['title', 'toc', 'sticky'],

		mounted(){
		},

		data(){
			return {

			}
		},

		computed: {
			currentUrl(){
				return this.$route.path.replace(/\/$/, "")
			}
		},

		methods:{
			trimmedUrl(url){
				return url.replace(/\/$/, "")
			}
		}

	}
</script>
